export default __webpack_public_path__ + "static/media/NOVO_TEMPO.2148082b.png";